module.exports = __webpack_public_path__ + "img/floppy-disk.5df65cb0.svg";